import type { GenArtModelDescriptor } from "./genArtCatalog";

export interface GenArtHeroPreviewProps {
	readonly model: GenArtModelDescriptor;
}

export function GenArtHeroPreview({ model }: Readonly<GenArtHeroPreviewProps>) {
	return (
		<div
			aria-hidden="true"
			style={{
				position: "absolute",
				inset: 0,
				overflow: "hidden",
			}}
		>
			{/* biome-ignore lint/performance/noImgElement: full-bleed local artwork must preserve cover semantics in the static export */}
			<img
				src={model.heroArtworkPath}
				alt=""
				style={{
					position: "absolute",
					inset: 0,
					width: "100%",
					height: "100%",
					objectFit: "cover",
				}}
			/>
			<div
				style={{
					position: "absolute",
					inset: 0,
					background:
						"linear-gradient(to bottom, rgb(0 0 0 / 0) 50%, rgb(0 0 0 / 0.55) 100%)",
				}}
			/>
			<div
				style={{
					position: "absolute",
					inset: 0,
					background:
						"linear-gradient(to bottom, rgb(0 0 0 / 0.32) 0%, rgb(0 0 0 / 0) 28%)",
				}}
			/>
		</div>
	);
}
